module.exports = __webpack_public_path__ + "img/15.25b21e26.png";